import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Switch, Redirect, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { timeframeAll } from 'selectors/indicator/timeframe';
import { relatedArticlesSelector } from 'selectors/indicator';
import fetch from 'services/fetch';
import classNames from 'classnames';
import getViewProperties from 'services/getViewProperties';

// Components
import ChartView from 'components/chartView';
import TableView from 'components/tableView';
import MapView from 'components/mapView';
import SnapshotView from 'components/snapshotView';
import TileNav from 'components/tileNav';
import Endnote from 'components/endnote';
import PostList from 'components/postList';

// Styles
import styles from './indicator.scss';

class Indicator extends Component {
  componentDidMount() {
    this.props.fetchIndicator(
      this.props.match.params.category,
      this.props.match.params.indicatorName
    );
    if (!this.props.updatedFromWP) {
      this.props.fetchFromWP(this.props.match.params.category);
    }
  }

  componentWillReceiveProps(next) {
    if (
      (next.match.params.indicatorName !==
        this.props.match.params.indicatorName) ||
      (next.match.params.category !== this.props.match.params.category)
    ) {
      this.props.fetchIndicator(
        next.match.params.category,
        next.match.params.indicatorName
      );
    }
  }

  render() {
    if (this.props.isFetching) {
      return null;
    }

    const {
      match: { params: { category, indicatorName, renderType } },
      location: { search = '' },
      enableChart,
      relatedArticles,
    } = this.props;

    const {
      isExporting,
      isMinimalView,
    } = getViewProperties(renderType);

    const navProps = {
      title: `${indicatorName} indicator menu`,
      items: [
        {
          destination: `/${category}/indicator/${indicatorName}/snapshot`,
          label: 'Snapshot',
          icon: 'aperture',
        },
        {
          destination: `/${category}/indicator/${indicatorName}/map`,
          label: 'Maps',
          icon: 'map',
        },
        {
          destination: `/${category}/indicator/${indicatorName}/table${search}`,
          label: 'Tables',
          icon: 'tables',
        },
        {
          destination: `/${category}/indicator/${indicatorName}/chart${search}`,
          label: 'Trends',
          icon: 'trends',
          visible: enableChart,
        },
      ],
    };

    return (
      <div className={styles.indicator}>
        <div className={styles.wrapper}>
          {!isMinimalView &&
            <div className={styles.navigation}>
              <TileNav {...navProps} />
            </div>
          }
          <div
            className={classNames(
              styles.content,
              {
                [styles.exporting]: isExporting,
              }
            )}
          >
            <Switch>
              <Route
                path="/:category/indicator/:indicatorName/snapshot"
                component={SnapshotView}
              />
              <Route
                path="/:renderType?/:category/indicator/:indicatorName/map/:context?/:year?"
                component={MapView}
              />
              <Route
                path="/:renderType?/:category/indicator/:indicatorName/table"
                component={TableView}
              />
              {enableChart && (
                <Route
                  path="/:renderType?/:category/indicator/:indicatorName/chart"
                  component={ChartView}
                />
              )}
              <Route
                exact
                path="/:category/indicator/:indicatorName/"
                render={() => (
                  <Redirect
                    to={`/${category}/indicator/${indicatorName}/snapshot`}
                  />
                )}
              />
            </Switch>
            {!isMinimalView &&
              <Endnote />
            }
          </div>
        </div>
        {!isMinimalView &&
          <footer className={styles.footer}>
            {relatedArticles && 0 < relatedArticles.length && (
              <div className={styles.wrapper}>
                <h2 className={styles.heading}>
                  Related
                  <span className={styles.screenReader}>
                    articles to this indicator
                  </span>
                </h2>
                <PostList posts={relatedArticles} />
              </div>
            )}
          </footer>
        }
      </div>
    );
  }
}

Indicator.defaultProps = {
  isFetching: false,
  enableChart: true,
  relatedArticles: [],
};

Indicator.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      category: PropTypes.string.isRequired,
      indicatorName: PropTypes.string.isRequired,
      renderType: PropTypes.string,
    }).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
  enableChart: PropTypes.bool,
  fetchIndicator: PropTypes.func.isRequired,
  fetchFromWP: PropTypes.func.isRequired,
  isFetching: PropTypes.bool,
  relatedArticles: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      image: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
      ]).isRequired,
      focusAreas: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
        })
      ),
      description: PropTypes.string,
      byline: PropTypes.string,
      publicationDate: PropTypes.string,
    })
  ),
  updatedFromWP: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  if (state.data.isFetching.length || !state.data.indicator) {
    return {
      isFetching: true,
      updatedFromWP: false,
    };
  }
  const { data: { indicator: { dataView }, allIndicators } } = state;
  return {
    isFetching: false,
    enableChart: timeframeAll(state) && 1 < timeframeAll(state).length,
    relatedArticles: relatedArticlesSelector(state),
    updatedFromWP: ('undefined' !== typeof allIndicators[dataView]) ?
      (allIndicators[dataView].updatedFromWP || false) :
      false,
  };
};

const dispatchProps = (dispatch) => ({
  fetchIndicator: (dataView, slug) => dispatch(fetch.indicator(dataView, slug)),
  fetchFromWP: (dataView) => dispatch(fetch.indicatorMeta(dataView)),
});

export default connect(
  mapStateToProps,
  dispatchProps,
)(Indicator);



// WEBPACK FOOTER //
// ./app/components/indicator/index.js